import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import resourcesToBackend from 'i18next-resources-to-backend';

import { logException } from 'helpers/loggers';
import { namespacePaths } from 'i18n/namespaces';

export { namespacePaths } from 'i18n/namespaces';

const modules = import.meta.glob('../**/__translations__/*.json');

i18n
  .use(
    resourcesToBackend(async (language: string, namespace: string) => {
      const folder = namespacePaths[namespace];
      if (!folder) throw new Error(`Unknown namespace: ${namespace}`);
      const path = `../${folder}/__translations__/${language}.json`;
      const loader = modules[path];
      if (!loader) throw new Error(`No translations found: ${path}`);
      const mod = (await loader()) as { default: Record<string, unknown> };
      return mod.default;
    }),
  )
  .use(initReactI18next)
  .init({
    // navigator.language can be undefined in non-browser environments (SSR, some test runners)
    lng: navigator.language?.split('-')[0],
    fallbackLng: 'en',
    interpolation: { escapeValue: false },
  })
  .catch((error: unknown) => logException({ error }));

export default i18n;
export { useTranslation, Trans } from 'react-i18next';
